/** @format */
import {
    largeTablet,
    mobile,
    smallTablet,
} from '@mpb-com/feather/helpers/media-queries';
import { css } from 'styled-components';

/* eslint-disable @mpb-com/mpb/use-design-tokens -- Legacy code: do not use as an example. */
const baseStyles = () => css`
    padding-top: 14.5rem;

    .product-trust-block__wrapper {
        background: linear-gradient(
            to top,
            var(--colors-surface-inverse) 85%,
            transparent 0%
        );
    }

    .product-trust-block__container {
        background:
            linear-gradient(
                to top,
                var(--colors-surface-inverse) 0%,
                rgba(0, 49, 68, 0) 60%
            ),
            var(--gradients-brand-primary);
        max-width: 110rem;
        margin: 0 auto;
        display: grid;
        border-radius: 0.8rem;
        grid-template-columns: 1fr 1fr;
        grid-template-areas:
            'content image'
            'trustpilot-widget trustpilot-widget';
        padding: 0 var(--layout-spacing-48);

        position: relative;
        &::after {
            position: absolute;
            bottom: 0;
            width: 100%;
            height: 80%;
            content: '';
            z-index: 2;
            background: linear-gradient(
                to top,
                var(--colors-surface-inverse) 10%,
                rgba(0, 49, 68, 0) 60%
            );
        }
    }

    .product-trust-block__content-container {
        grid-area: content;
        padding: var(--layout-spacing-72) 0;
        z-index: 3;
        color: var(--colors-text-secondary);
    }

    .product-trust-block__content {
        margin-bottom: var(--layout-spacing-8);
        padding-right: var(--layout-spacing-8);
    }

    .product-trust-block__trustpilot-widget {
        grid-area: trustpilot-widget;
        position: relative;
        height: 24rem;
        z-index: 3;
        width: 100%;
        justify-self: center;
        > div {
            position: absolute !important;
            top: 0;
            width: 100%;
            left: 0;
        }
    }

    .product-trust-block__image {
        grid-area: image;
        position: relative;
        img {
            z-index: 1;
            position: absolute;
            bottom: -7.2rem;
            left: 50%;
            transform: translateX(-50%);
        }
    }

    .product-trust-block__usp-blocks {
        max-width: 111rem;
        margin: 0 auto;
        display: flex;
        justify-content: space-evenly;
        background-color: var(--colors-surface-inverse);
        padding: var(--layout-spacing-72) var(--layout-spacing-24);
        .product-trust-block__usp {
            color: var(--colors-text-inverse);
            display: flex;
            flex-direction: column;
            align-items: center;
            max-width: 32rem;
            text-align: center;

            .product-trust-block__icon {
                margin-bottom: var(--layout-spacing-24);
            }

            .product-trust-block__link__icon {
                cursor: pointer;
                margin-left: var(--layout-spacing-4);
            }

            p {
                margin-bottom: var(--layout-spacing-24);
            }
        }
    }
`;
/* eslint-enable @mpb-com/mpb/use-design-tokens -- Legacy code: do not use as an example. */

const TRUST_PILOT_OVERFLOW = '2.4rem';

/* eslint-disable @mpb-com/mpb/use-design-tokens -- Legacy code: do not use as an example. */
const largeTabletStyles = () => css`
    padding-top: var(--layout-spacing-96);

    .product-trust-block__container {
        border-radius: 0;

        grid-template-areas:
            'content content'
            'image image'
            'trustpilot-widget trustpilot-widget';

        text-align: center;

        &::after {
            height: 45%;
            background: linear-gradient(
                to top,
                var(--colors-surface-inverse) 70%,
                rgba(0, 49, 68, 0) 100%
            );
        }
    }

    .product-trust-block__content-container {
        padding: var(--layout-spacing-40) 0 var(--layout-spacing-64);
    }

    .product-trust-block__content {
        padding-right: 0;
    }

    .product-trust-block__trustpilot-widget {
        max-width: 52rem;
        > div {
            top: -${TRUST_PILOT_OVERFLOW};
        }
    }

    .product-trust-block__image {
        max-height: 34.4rem;
        display: flex;
        justify-content: center;
        img {
            object-fit: contain;
            position: static;
            bottom: unset;
            left: unset;
            transform: unset;
        }
    }

    .product-trust-block__usp-blocks {
        flex-direction: column;
        align-items: center;
        padding-top: calc(var(--layout-spacing-64) - ${TRUST_PILOT_OVERFLOW});
        .product-trust-block__usp {
            margin-bottom: var(--layout-spacing-48);
        }
    }
`;
/* eslint-enable @mpb-com/mpb/use-design-tokens -- Legacy code: do not use as an example. */

const smallTabletStyles = () => css`
    .product-trust-block__container {
        padding: 0;
    }
    .product-trust-block__content-container,
    .product-trust-block__image {
        padding-left: var(--layout-spacing-24);
        padding-right: var(--layout-spacing-24);
    }
`;

const mobileStyles = () => css`
    padding-top: var(--layout-spacing-64);

    .product-trust-block__content-container,
    .product-trust-block__image,
    .product-trust-block__usp-blocks {
        padding-left: var(--layout-spacing-16);
        padding-right: var(--layout-spacing-16);
    }
`;

/* eslint-disable @typescript-eslint/no-unsafe-argument -- Legacy code: do not use as an example. */
export const styles = () => css`
    ${baseStyles()}
    ${largeTablet(largeTabletStyles())}
    ${smallTablet(smallTabletStyles())}
    ${mobile(mobileStyles())}
`;
/* eslint-enable @typescript-eslint/no-unsafe-argument -- Legacy code: do not use as an example. */
